exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-6b61aee6]:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports
